import { readRemaining1kbpbgdrq25q1 as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { contentLength2suzxu1lzutku as contentLength } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkContentLength1q7i15kkn2eie as checkContentLength } from './utils.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel1cb89sbyipkce as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteChannelCtor.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *save(_this__u8e3s4, $completion) {
  if (_this__u8e3s4 instanceof SavedHttpCall())
    return _this__u8e3s4;
  var responseBody = readByteArray(yield* readRemaining(_this__u8e3s4.t5g().g5j(), $completion));
  return SavedHttpCall().p5k(_this__u8e3s4.o5g_1, _this__u8e3s4.r5i(), _this__u8e3s4.t5g(), responseBody);
}
var SavedHttpCallClass;
function SavedHttpCall() {
  if (SavedHttpCallClass === VOID) {
    class $ extends HttpClientCall() {
      constructor(client, request, response, responseBody) {
        return new.target.p5k(client, request, response, responseBody);
      }
      static p5k(client, request, response, responseBody) {
        var $this = this.q5i(client);
        $this.n5k_1 = responseBody;
        $this.q5g_1 = new (SavedHttpRequest())($this, request);
        $this.r5g_1 = new (SavedHttpResponse())($this, $this.n5k_1, response);
        checkContentLength(contentLength(response), fromInt($this.n5k_1.length), request.z5i());
        $this.o5k_1 = true;
        return $this;
      }
      t5i() {
        return this.o5k_1;
      }
    }
    initMetadataForClass($, 'SavedHttpCall', VOID, VOID, VOID, [0, 1]);
    SavedHttpCallClass = $;
  }
  return SavedHttpCallClass;
}
var SavedHttpRequestClass;
function SavedHttpRequest() {
  if (SavedHttpRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.q5k_1 = origin;
        this.r5k_1 = call;
      }
      y5i() {
        return this.r5k_1;
      }
      cw() {
        return this.q5k_1.cw();
      }
      z5i() {
        return this.q5k_1.z5i();
      }
      a5j() {
        return this.q5k_1.a5j();
      }
      s5i() {
        return this.q5k_1.s5i();
      }
      a2o() {
        return this.q5k_1.a2o();
      }
      y51() {
        return this.q5k_1.y51();
      }
    }
    initMetadataForClass($, 'SavedHttpRequest', VOID, VOID, [HttpRequest()]);
    SavedHttpRequestClass = $;
  }
  return SavedHttpRequestClass;
}
var SavedHttpResponseClass;
function SavedHttpResponse() {
  if (SavedHttpResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, body, origin) {
        super();
        this.s5k_1 = call;
        this.t5k_1 = body;
        this.u5k_1 = origin.h5j();
        this.v5k_1 = origin.i5j();
        this.w5k_1 = origin.j5j();
        this.x5k_1 = origin.k5j();
        this.y5k_1 = origin.y51();
        this.z5k_1 = origin.cw();
      }
      y5i() {
        return this.s5k_1;
      }
      h5j() {
        return this.u5k_1;
      }
      i5j() {
        return this.v5k_1;
      }
      j5j() {
        return this.w5k_1;
      }
      k5j() {
        return this.x5k_1;
      }
      y51() {
        return this.y5k_1;
      }
      cw() {
        return this.z5k_1;
      }
      g5j() {
        return ByteReadChannel(this.t5k_1);
      }
    }
    initMetadataForClass($, 'SavedHttpResponse');
    SavedHttpResponseClass = $;
  }
  return SavedHttpResponseClass;
}
//region block: exports
export {
  save as savemjbqee915hc5,
};
//endregion

//# sourceMappingURL=SavedCall.mjs.map
